import React from "react";
import { RespostaSolicitacaoWrapper, Title } from "./styles";

const RespostaSolicitacao = ({ children, respostaRef, tema }) => {
  return (
    <>
      <Title ref={respostaRef} tema={tema}>
        Resposta da solicitação:
      </Title>
      <RespostaSolicitacaoWrapper>{children}</RespostaSolicitacaoWrapper>
    </>
  );
};

export default RespostaSolicitacao;
